import Clear from './../layouts/Clear.vue';

export default {
  path: '/movimentActivesList',
  component: Clear,
  children: [
    {
      path: '',
      name: 'movimentActivesList.index',
      component: () => import('@/views/movimentActivesList/index.vue'),
    },
  ],
};
